//
//
//
//
//
//
//
//
//

export default {
  props: {
    xmIconList: {
      type: Array,
      default: null
    }
  },

  methods: {
    clickTag (iconItem) {
      this.$emit("click-tag", iconItem)
    }
  }
}  



// WEBPACK FOOTER //
// ./src/components/xc_time/album-tags/album-tags-pc.vue